import React, { useContext, useEffect, useState } from 'react'
import { t } from 'i18next';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import AccessContext from '../../context/AccessContext/AccessContext';
import { getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import { Spinner } from 'reactstrap';
import ItemSelectableWithCheck from '../ItemSelectable/ItemSelectableWithCheck';
import ErrorScreen from '../MessagesScreens/ErrorScreen';
import VehicleSelectableCard from '../Vehicle/VehicleSelectableCard';
import useWindowSize from '../../customHooks/useWindowSize';

const VehiclesSelectable = () => {

  const { getAccessVehicles, searchAccessVehicles, showMoreAccessVehicles, accessVehiclesState, setAccessVehiclesSelected, cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
  const { accessVehicles, isFetching, error, message, reg_to, isFetchingShowMore, canShowMore, accessVehiclesSelected } = accessVehiclesState;

  const { accessState, setStep } = useContext(AccessContext);
  const { employee, type, accessWithEquipmentOrTools } = accessState;

  const { windowWidth } = useWindowSize();

  const isAccess = ['ACCESS', 'ACCESS_VISIT'].some(typeOption => typeOption === type);

  const initialStateFilter = {
    employee_id: employee.id,
    opening_id: getUserOpening().codigo,
    building_id: String(getUserBuilding().buildingId),
    search_text: "",
    reg_from: 1,
    page_length: 10
  };

  const [filter, setFilter] = useState(initialStateFilter);

  const [vehiclesSelected, setVehiclesSelected] = useState(accessVehiclesSelected);

  const [noAccessVehicle, setNoAccessVehicle] = useState(false);

  const handleNoAccessVehicle = (e) => {
    const { checked } = e.target;
    setNoAccessVehicle(checked);
    setVehiclesSelected([]);
  };

  const handleSelectVehicle = (e, newVehicle) => {
    const { checked } = e.target;
    setNoAccessVehicle(false);
    if (checked) {
      setVehiclesSelected([...vehiclesSelected, newVehicle])
    } else {
      setVehiclesSelected(vehiclesSelected.filter((vehicleSelected) => vehicleSelected.vehicle_natural_id !== newVehicle.vehicle_natural_id))
    }
  };

  const isAdded = (id) => {
    const isAlReadyAdded = vehiclesSelected.some((vehicleSelected) => vehicleSelected.vehicle_natural_id === id);
    return isAlReadyAdded;
  };

  const handleSetFilter = (value) => {
    const newFilter = { ...filter, search_text: value };
    setFilter(newFilter);
  };

  const search = (e) => {
    if (e.key === 'Enter') {
      const newFilter = { ...filter, reg_from: 1 };
      setFilter(newFilter);
      searchAccessVehicles(newFilter, type);
    }
  };

  const showMore = () => {
    const newFilter = { ...filter, reg_from: reg_to + 1 };
    setFilter(newFilter);
    showMoreAccessVehicles(newFilter, type)
  };

  const handleShowMore = (e) => {
    const bottom = (e.target.scrollHeight - e.target.scrollTop) <= (e.target.clientHeight + 1);
    if (bottom && canShowMore) {
      showMore();
    }
  };

  const handleNextStep = () => {
    if (error) return

    setAccessVehiclesSelected(vehiclesSelected);
    if (isAccess) {
      const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');;

      const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

      if (accessWithEquipmentOrTools) {
        setStep('SELECT_EQUIPMENT_OR_TOOLS')
        return
      }

      if (haveAccessBuildings) {
        setStep('SELECT_AREA')
        return
      }

      if (havePersonsToVisit) {
        setStep('SELECT_PERSON_TO_VISIT')
        return
      }

    }
    setStep('DETAIL')
  };

  const handleReturnStep = () => {
    setStep('ACCESS_WITH')
    cleanAccessVehiclesState();
  }

  useEffect(() => {
    getAccessVehicles(filter, type);
    // eslint-disable-next-line
  }, []);

  return (
    <div className='d-flex flex-column justify-content-between h-100'>

      <div>
        <div>
          <h5 className='d-sm-block d-none fw-bold mb-4'>{t('SELECT_VEH')}</h5>
          <input
            type="text"
            className="form-control"
            placeholder={t('SEARCH')}
            name='search_text'
            value={filter.search_text}
            onKeyPress={search}
            onChange={(e) => handleSetFilter(e.target.value)}
          />
        </div>

        {isFetching && (
          <div className='d-flex justify-content-center mt-5'>
            <Spinner />
          </div>
        )}

        {(!isFetching && !error) && (
          <div
            className='d-flex flex-column gap-2 no-show-scroll mt-3'
            style={{ maxHeight: windowWidth <= 576 ? '430px' : '380px', overflowX: 'auto' }}
            onScroll={handleShowMore}
          >
            {accessVehicles.map((vehicle, idx) =>
              <VehicleSelectableCard
                key={idx}
                vehicle={vehicle}
                checked={isAdded(vehicle.vehicle_natural_id)}
                onChange={(e) => handleSelectVehicle(e, vehicle)}
              />
            )}

            <div className='mt-2'>
              <ItemSelectableWithCheck
                name={'noAccessVehicle'}
                checked={noAccessVehicle}
                onChange={handleNoAccessVehicle}
              >
                <div>
                  <p className='m-0 vehicleName-card'>{t('NO_CAR')}</p>
                  <p className='m-0 vehiclePatent-card'>{isAccess ? t('NO_CAR_ACCESS') : t('NO_CAR_EXIT')}</p>
                </div>
              </ItemSelectableWithCheck>
            </div>

            {isFetchingShowMore && (
              <div className='mt-2 mt-2 d-flex justify-content-center'>
                <Spinner />
              </div>
            )}

          </div>
        )}

      </div>

      {error && (<ErrorScreen title={'Error'} description={message} />)}

      <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
        <div className="w-75">
          <ButtonBlackReturn
            title={t('GET_BACK')}
            onClick={handleReturnStep}
          />
        </div>
        <div className="w-50">
          <ButtonBlue
            className='w-100'
            disabled={error}
            onClick={handleNextStep}
          >
            {t('NEXT')}
          </ButtonBlue>
        </div>
      </div>

    </div>
  )
}

export default VehiclesSelectable